"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVICE_CHANGED = exports.goToCurrentLocation = exports.resetView = exports.initializeOutageMap = exports.VIEW_CHANGED = exports.goToArea = exports.navigateToPoint = exports.setActiveLayer = exports.setTypeOfMap = exports.zoomOut = exports.zoomIn = exports.clearSelectedIcon = void 0;

var _actions = require("kmap-redux/dist/actions");

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

var _map = _interopRequireDefault(require("../config/map"));

var _infoboxActions = require("./infoboxActions");

var _sc = require("./sc4");

var _messageActions = require("./messageActions");

var ServiceGeoJson = _interopRequireWildcard(require("../assets/county.json"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var clearSelectedIcon = function clearSelectedIcon() {
  return function (dispatch) {
    dispatch({
      type: _infoboxActions.INFOBOX_CLOSE
    });
    dispatch((0, _actions.removeSelected)());
  };
};

exports.clearSelectedIcon = clearSelectedIcon;

var zoomIn = function zoomIn() {
  return function (dispatch) {
    var currentView = dispatch((0, _actions.getView)());
    var nextZoomLevel = currentView.view.zoom + 1;
    dispatch(clearSelectedIcon());
    dispatch((0, _actions.setZoomLevel)(nextZoomLevel));
  };
};

exports.zoomIn = zoomIn;

var zoomOut = function zoomOut() {
  return function (dispatch) {
    var currentView = dispatch((0, _actions.getView)());
    var nextZoomLevel = currentView.view.zoom - 1;
    dispatch(clearSelectedIcon());
    dispatch((0, _actions.setZoomLevel)(nextZoomLevel));
  };
};

exports.zoomOut = zoomOut;

var setTypeOfMap = function setTypeOfMap(mapType) {
  return function (dispatch) {
    dispatch((0, _actions.setMapType)(mapType));
  };
};

exports.setTypeOfMap = setTypeOfMap;

var setActiveLayer = function setActiveLayer(nextLayer) {
  return function (dispatch, getState) {
    var _getState$allowedLaye; // const currentLayer = getState().layerVisibilityReducer.activeLayer;


    dispatch(clearSelectedIcon());
    (_getState$allowedLaye = getState().allowedLayerReducer.loadshedLayers) === null || _getState$allowedLaye === void 0 ? void 0 : _getState$allowedLaye.forEach(function (layer) {
      dispatch((0, _actions.setLayerVisibility)(layer.name, undefined, nextLayer.includes(layer.name)));
    });
    /* loadShedLayers.forEach((layer: LoadShedLayer): void => {
      if (nextLayer.includes(layer.name)) {
        if (!currentLayer.includes(layer.name)) {
          dispatch(setLayerVisibility(layer.name, undefined, true));
        }
      } else if (currentLayer.includes(layer.name)) {
        dispatch(setLayerVisibility(layer.name, undefined, false));
      }
    }); */
  };
};

exports.setActiveLayer = setActiveLayer;

var navigateToPoint = function navigateToPoint(point, nextZoom) {
  return function (dispatch, getState) {
    var currentView = getState().mapViewReducer.mapView;
    var nextZoomLevel = currentView.zoom + 3 < _map.default.maxZoom ? currentView.zoom + 3 : _map.default.maxZoom;
    var mapView = {
      center: point,
      zoom: nextZoom || nextZoomLevel
    };
    dispatch((0, _actions.goToPoint)(mapView, null));
  };
};

exports.navigateToPoint = navigateToPoint;
var geocoder;

var goToArea = function goToArea(searchCriteria) {
  return function (dispatch) {
    if (!geocoder) {
      geocoder = new window.google.maps.Geocoder();
    }

    if (geocoder) {
      geocoder.geocode({
        address: searchCriteria,
        bounds: _map.default.allowedBBox
      }, function (results, status) {
        var boundingBox = new window.google.maps.LatLngBounds({
          lat: _map.default.allowedBBox.south,
          lng: _map.default.allowedBBox.west
        }, {
          lat: _map.default.allowedBBox.north,
          lng: _map.default.allowedBBox.east
        });

        if (status === window.google.maps.GeocoderStatus.OK) {
          var result = results.find(function (geocodeResult) {
            return boundingBox.contains(geocodeResult.geometry.location);
          });

          if (result) {
            if (result.geometry.bounds) {
              dispatch((0, _actions.goToBounds)(result.geometry.bounds.toJSON()));
            } else {
              dispatch(navigateToPoint(result.geometry.location.toJSON(), _map.default.maxZoom));
            }
          }
        }
      });
    } // dispatch(goToAddress(searchCriteria)).then(data => console.log(data));

  };
};

exports.goToArea = goToArea;
var VIEW_CHANGED = 'VIEW_CHANGED';
exports.VIEW_CHANGED = VIEW_CHANGED;

var initializeOutageMap = function initializeOutageMap(userType, userMuniCounty, initialMapLocation) {
  return function (dispatch) {
    var initialView = _map.default.initialView;
    var viewRaw = window.localStorage.getItem('mapview');

    if (viewRaw) {
      var view = JSON.parse(viewRaw);

      if (view.center && view.center.lat && view.center.lng && view.zoom) {
        initialView = view;
      }
    }

    dispatch((0, _actions.initializeKmap)({
      id: 'map',
      api: _kubraKmap.default.api.GOOGLE,
      // Supported GOOGLE, LEAFLET, BING.
      apiKey: 'client=gme-ifactorconsulting1',
      center: initialView.center,
      zoom: initialView.zoom,
      allowedBBox: _map.default.allowedBBox,
      featureStyles: [{
        featureType: 'poi',
        elementType: 'labels',
        visible: false
      }],
      libraries: ['places'],
      clickableIcons: false,
      minZoom: _map.default.minZoom,
      maxZoom: _map.default.maxZoom
    })).then(function () {
      dispatch((0, _actions.registerMapEvent)(_kubraKmap.default.event.CLICK, function () {
        dispatch(clearSelectedIcon());
      }));
      dispatch((0, _actions.registerMapEvent)(_kubraKmap.default.event.VIEWCHANGED, function (view) {
        dispatch({
          type: VIEW_CHANGED,
          view: view
        });
      }));
      dispatch((0, _actions.registerMapEvent)('KMapEvent.zoomChange', function () {
        dispatch(clearSelectedIcon());
      }));
      dispatch((0, _actions.loadLayer)('servicearea', [ServiceGeoJson], {
        type: _kubraKmap.default.layerType.VECTOR,
        format: _kubraKmap.default.layerFormat.GEOJSON,
        compress: true,
        zIndex: 200,
        showMarker: _kubraKmap.default.layerShowMarker.NEVER,
        showShape: _kubraKmap.default.layerShowShape.ALWAYS,
        clickable: false,
        visible: true,
        style: {
          ranges: [{
            showInLegend: false,
            rangeCriteria: [],
            rangeStyles: {
              shape: {
                borderColor: '#6955FB',
                borderOpacity: 1,
                borderWeight: 2,
                fillColor: '#00f',
                opacity: 0
              }
            },
            rangeLegendIcon: null,
            rangeLabel: null
          }]
        }
      }));
      Promise.resolve().then(function () {
        dispatch((0, _sc.refreshData)(userType, userMuniCounty));
      }).then(function () {
        dispatch({
          type: _messageActions.HIDE_MESSAGE
        });
      });
    }).then(function () {
      if (initialMapLocation) {
        dispatch(goToArea(initialMapLocation));
      }
    });
  };
};

exports.initializeOutageMap = initializeOutageMap;

var resetView = function resetView() {
  return function (dispatch) {
    dispatch((0, _actions.setView)(_map.default.initialView));
  };
};

exports.resetView = resetView;

var goToCurrentLocation = function goToCurrentLocation() {
  return function (dispatch) {
    // eslint-disable-next-line no-undef
    navigator.geolocation.getCurrentPosition(function (position) {
      var gpsView = {
        center: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        zoom: _map.default.maxZoom
      };
      dispatch((0, _actions.goToGPS)(gpsView)).catch(function (e) {
        dispatch({
          type: _messageActions.SHOW_MESSAGE,
          message: e.message
        });
      });
    }, function (error) {
      var _errorMap;

      var errorMap = (_errorMap = {}, _defineProperty(_errorMap, error.PERMISSION_DENIED, 'User denied the request for Geolocation.'), _defineProperty(_errorMap, error.POSITION_UNAVAILABLE, 'Location information is unavailable.'), _defineProperty(_errorMap, error.TIMEOUT, 'The request to get location timed out.'), _errorMap);
      dispatch({
        type: _messageActions.SHOW_MESSAGE,
        message: errorMap[error.code]
      });
    });
  };
};

exports.goToCurrentLocation = goToCurrentLocation;
var DEVICE_CHANGED = 'DEVICE_CHANGED';
exports.DEVICE_CHANGED = DEVICE_CHANGED;